import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import AboutSection from "./components/AboutSection";
import FullCategoryCards from "./components/FullCategoryCards";
import ComparisonSection from "./components/ComparisonSection";
import FAQArticleSection from "./components/FAQArticleSection";
import Footer from "./components/Footer";
import JsonLd from "@/components/base/JsonLd";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://cssbuyspreadsheet.my";

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "CSSBuy Spreadsheet",
  "url": siteUrl,
  "description": "Guia completo para comprar da China com segurança usando CSSBuy Spreadsheet. Tabelas, comparações e dicas de segurança para compradores em Portugal.",
  "inLanguage": "pt-PT",
  "potentialAction": {
    "@type": "SearchAction",
    "target": `${siteUrl}/?s={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "CSSBuy Spreadsheet",
  "url": siteUrl,
  "description": "Guia independente sobre CSSBuy Spreadsheet — a ferramenta essencial para compradores internacionais encontrarem produtos de alta qualidade da China com os melhores preços.",
  "sameAs": ["https://kaspreadsheet.com/"],
};

export default function Home() {
  useEffect(() => {
    document.title = "CSSBuy Spreadsheet 2026 | Guia Completo para Comprar da China com Segurança";
  }, []);

  return (
    <>
      <JsonLd data={websiteSchema as unknown as Record<string, unknown>} />
      <JsonLd data={organizationSchema as unknown as Record<string, unknown>} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <AboutSection />
        <FullCategoryCards />
        <ComparisonSection />
        <FAQArticleSection />
      </main>
      <Footer />
    </>
  );
}